var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79297 0.833984C2.13815 0.833984 2.41797 1.11381 2.41797 1.45898V3.00065L3.85186 2.71387C5.2273 2.43878 6.65306 2.56969 7.95541 3.09063L8.29981 3.22839C9.48721 3.70335 10.7941 3.79204 12.0348 3.48187C12.5606 3.35042 12.9828 3.92032 12.704 4.38508L11.6385 6.16083C11.354 6.63513 11.2117 6.87227 11.1779 7.13023C11.1639 7.23783 11.1639 7.34681 11.1779 7.45441C11.2117 7.71236 11.354 7.94951 11.6385 8.42381L12.9391 10.5914C13.1981 11.0231 12.9664 11.5823 12.478 11.7044L12.3946 11.7252C10.92 12.0939 9.3667 11.9885 7.95541 11.424C6.65306 10.903 5.2273 10.7721 3.85186 11.0472L2.41797 11.334V18.1257C2.41797 18.4708 2.13815 18.7507 1.79297 18.7507C1.44779 18.7507 1.16797 18.4708 1.16797 18.1257V1.45898C1.16797 1.11381 1.44779 0.833984 1.79297 0.833984Z",
    fill: "#FF9700",
    stroke: "#FF9700",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.ef93b059fd88ff648e4a73903a96cfe8.svg";
export { ForwardRef as ReactComponent };